const key = "j10bot.login.preferences.v1";
export function readLoginPreferences(storage) {
 try {
  const value = JSON.parse(storage.getItem(key) || "null");
  return value?.remember === true && typeof value.email === "string" && value.email.length <= 320 ? { remember:true, email:value.email } : { remember:false, email:"" };
 } catch { return { remember:false, email:"" }; }
}
export function saveLoginPreferences(storage, remember, email) {
 try {
  if (remember) storage.setItem(key, JSON.stringify({remember:true,email:String(email || "").slice(0,320)}));
  else storage.removeItem(key);
 } catch { /* Login still works when browser storage is unavailable. */ }
}
